<template>
  <v-card v-if="entregaSeleccionada" elevation="10" color="light-blue">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-subtitle>
          <v-btn rounded class="itemUnaEntrega" @click="generatedActions('clickEnVerMapa')"
                 :color="entregaSeleccionada.Latitud ===0 ? 'orange' : 'green darken-2' " block dark>
            Ver en el mapa
            <v-icon right>
              {{ entregaSeleccionada.Latitud === 0 ? 'mdi-map-marker-question-outline' : 'mdi-google-maps' }}
            </v-icon>
          </v-btn>
        </v-list-item-subtitle>
        <v-list-item-title>
          <v-chip class="ma-2 text-h6 itemUnaEntrega" label>
            Turno de entrega: # {{ entregaSeleccionada.OrdenEntrega }}
          </v-chip>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list class="transparent">

      <v-list-item>
        <v-list-item-icon>
          <v-icon right color="white">mdi-receipt</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle class="white--text subtitle-1">
          Comprobante : <p class="text-h6"> {{ entregaSeleccionada.Comprobante }} </p>
        </v-list-item-subtitle>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon right color="white">mdi-barcode-scan</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle class="white--text subtitle-1">Remitos :</v-list-item-subtitle>
      </v-list-item>
      <p class="overflow-visible white--text subtitle-1 ml-16 font-weight-bold">
        {{ entregaSeleccionada.Remitos }}
      </p>

      <v-list-item>
        <v-list-item-icon>
          <v-icon right color="white">mdi-account-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle class="white--text subtitle-1">
          Cliente : <p class="text-h6">{{ entregaSeleccionada.NombreCliente }}</p>
        </v-list-item-subtitle>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon right color="white">mdi-archive</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle class="white--text subtitle-1">
          N° Bultos : <p class="text-h6"> {{ entregaSeleccionada.Bultos }} </p>
        </v-list-item-subtitle>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon right color="white">mdi-home-city</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle class="white--text subtitle-1">
          Destino : <p class="text-h6"> {{ entregaSeleccionada.NombreDestino }} </p>
        </v-list-item-subtitle>

      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon right color="white">mdi-map-marker-radius-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle class="white--text subtitle-1">
          Domicilio : <p class="text-h6"> {{ entregaSeleccionada.Domicilio }} </p>
        </v-list-item-subtitle>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon right color="white">mdi-map-search-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle class="white--text subtitle-1">
          Localidad :
        </v-list-item-subtitle>
      </v-list-item>
      <p class="overflow-visible white--text text-h6 ml-16">
        {{ entregaSeleccionada.Localidad }}
      </p>


    </v-list>
    <capture-foto
        ref="dialogFoto"
        @guardar="generatedActions"
    />

    <v-divider></v-divider>
    <v-card-actions>
      <v-row class="mx-4">
        <v-btn @click="fotoCaptureEntrega('clickEnOk')" class="mt-6 my-2" color="green" block dark>
          OK
          <v-icon right>mdi-checkbox-marked-circle</v-icon>
        </v-btn>
        <v-btn @click="fotoCaptureEntrega('clickEnNo')" class="my-2" color="red" block dark>
          NO
          <v-icon right>mdi-close-octagon</v-icon>
        </v-btn>

        <v-btn @click="fotoCaptureEntrega('clickEnParcial')" class="my-2" color="orange" block dark>
          Parcial
          <v-icon right>mdi-progress-check</v-icon>
        </v-btn>

      </v-row>
    </v-card-actions>
    <v-card-actions class="mx-4">
      <v-btn @click="cancelar" color="rgb(37, 150, 190)" block dark>
        <v-icon left>mdi-arrow-left-circle</v-icon>
        Volver a la lista
      </v-btn>
    </v-card-actions>

  </v-card>
</template>
<script>
import CaptureFoto from "./CaptureFoto";
import {nanoid} from 'nanoid'

export default {
  name: 'card-confirm-entrega',
  components: {CaptureFoto},
  props: {
    entregaSeleccionada: {}
  },
  data: () => ({
    estadoEntrega: '',
    hashNano: ''
  }),

  methods: {
    generatedActions() {
      this.$emit(`${this.estadoEntrega}`)
    },
    cancelar(){
      this.estadoEntrega = 'clickEnCancelar'
      this.generatedActions()
    },
    async fotoCaptureEntrega(action) {
      this.estadoEntrega = action
      if (this.entregaSeleccionada.PedirFotoDocumentacionEntrega || Object.is(this.estadoEntrega,"clickEnNo") ) {
        await this.generarNombreFile(action)
        this.$refs.dialogFoto.openDialog(this.estadoEntrega)
      } else
        this.generatedActions()

    },
    async generarNombreFile(estado) {
      this.hashNano = nanoid()

      switch (estado) {
        case "clickEnNo":
          const hash = await this.$store.dispatch("choferes/getHashByPhoto", this.entregaSeleccionada.Id)
          this.$store.commit('choferes/set_nameFile', `a54_cfne_${this.entregaSeleccionada.Id}_${hash}`)
          break
        default:
          this.$store.commit('choferes/set_hashGenerateNano', this.hashNano)
          this.$store.commit('choferes/set_nameFile', `a54_cfde_${this.entregaSeleccionada.Id}_${this.hashNano}`)
          break
      }
      return true
    },

    closeFoto() {
      this.$refs.dialogFoto.openCapture = false
    }
  }
}
</script>
<style scoped>
.itemUnaEntrega {
  font-weight: 900;
  font-family: "Helvetica Neue";
}
</style>
